import React from 'react';

const AnimationControls = ({ isDay, onDayNightChange }) => {
	return (
		<div className="animation-controls">
			<div className="onoffswitch">
				<input
					type="checkbox"
					name="onoffswitch"
					className="onoffswitch-checkbox"
					id="myonoffswitch"
					checked={isDay}
					onChange={onDayNightChange}
				/>
				<label className="onoffswitch-label" htmlFor="myonoffswitch">
					<span className="onoffswitch-inner" />
					<span className="onoffswitch-switch" />
				</label>
			</div>
		</div>
	);
};

export default AnimationControls;



// WEBPACK FOOTER //
// ./src/components/common/AninamationControls.js